import {FC} from "react";

import TableAdminContractsList from "../../../components/table/contracts/TableAdminContractsList";

import styles from './contractsList.module.scss'
import TableCustomerContractsList from "../../../components/table/contracts/TableCustomerContractsList";

const ContractsList: FC = () => {
    const data = JSON.parse(localStorage.getItem("userData") as string);

    return (
        <div className={styles.projectsList}>
            {!data.isCustomer ? (
                <TableAdminContractsList />
            ) : (
                <TableCustomerContractsList />
             )}
        </div>
    );
};

export default ContractsList;
